const commitPrice = {
  path: 'commitPrice',
  component: resolve => require(['../../../../components/pages/signUp/commitPrice'], resolve)
}
export default commitPrice
